import React, { useContext, useEffect, useState } from "react";
import { notAssessableAndAssessableOptions } from "../../../Options/commonOptions";
import CheckListFBYRadioItems from "../../../../../blocks/FormItems/CheckListFBYRadioItems";
import {
  leftRightBothOptions,
  visionOptions,
} from "../../../Options/functionalAsessmentOptions";
import DeselectableRadioGroup from "../../../../../blocks/FormItems/DeselectableRadioGroup";
import { hexToRgba } from "../../../../../helpers/utility";
import {theme} from "antd";
const Vision = ({ context, form }) => {
  const [refresh, setRefresh] = useState(false);
  const { formData } = useContext(context);
  const { token } = theme.useToken();
  
  const [checkboxes, setCheckBoxes] = useState([]);
  useEffect(() => {
    const initialCheckboxes = visionOptions.reduce((acc, checkbox) => {
      acc[checkbox.value] =
        formData?.functional_status?.vision_details?.[checkbox.value];
      return acc;
    }, {});
    setCheckBoxes(initialCheckboxes);
  }, [formData]);
  return (
    <>
      <DeselectableRadioGroup
        label={"Vision"}
        name={["vision_details", "vision"]}
        form={form}
        options={notAssessableAndAssessableOptions}
        setRefresh={setRefresh}
      />
      {form.getFieldValue(["vision_details", "vision"]) === "assessable" && (
        <div
                    className="subsection-card"
                    style={{
                      borderLeft: `2px solid ${hexToRgba(token.colorPrimaryHover, 0.2)}`,
                      background: "transparent",
                      marginTop: "8px",
                      padding: "8px 12px",
                      borderRadius: "8px",
                    }}
                  >
          <CheckListFBYRadioItems
            checkBoxOptions={visionOptions}
            radioOptions={leftRightBothOptions}
            checkboxes={checkboxes}
            setCheckboxes={setCheckBoxes}
            keyChain={"vision_details"}
            form={form}
          />
        </div>
      )}
    </>
  );
};

export default Vision;
